import { Space } from 'antd';
import { useContext } from 'react';

import { CATEGORIES_LABEL, VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const VisitsCategoriesLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);
  const additionalCondition =
    (
      serverFilters.VisitsFilter[filterGroupIndex]?.Values[0]
        .ServiceCategoryIds || []
    ).length > 0;

  return (
    <Space
      className={`visits-categories-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>{CATEGORIES_LABEL}</span>
      <ClientFilterTag
        filters={filters}
        serverFilters={serverFilters}
        filtersArea={VISITS_FILTER}
        filterGroupIndex={filterGroupIndex}
        setFilters={setFilters}
        setServerFilters={setServerFilters}
        valueKey={
          'ServiceCategoryIds' as keyof NClientsList.VisitsFilterUnitValue['ServiceCategoryIds']
        }
        additionalCondition={additionalCondition}
      >
        {`Выбрано: ${
          (
            serverFilters?.VisitsFilter?.[filterGroupIndex]?.Values?.[0]
              ?.ServiceCategoryIds || []
          )?.length
        }`}
      </ClientFilterTag>
    </Space>
  );
};
